import { useState } from "react";

const STORAGE_KEY = "airl:visit:v1";
const REVISIT_GAP_MS = 30 * 60 * 1000;
const DEFAULT_LOOKBACK_MS = 6 * 24 * 60 * 60 * 1000;

interface VisitRecord {
  base: number;
  seen: number;
}

function readCutoff(): number {
  const now = Date.now();
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const previous = saved ? (JSON.parse(saved) as Partial<VisitRecord>) : null;
    let next: VisitRecord;
    if (!previous?.base || !previous.seen) {
      next = { base: now - DEFAULT_LOOKBACK_MS, seen: now };
    } else if (now - previous.seen > REVISIT_GAP_MS) {
      next = { base: previous.seen, seen: now };
    } else {
      next = { base: previous.base, seen: now };
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next.base;
  } catch {
    return now - DEFAULT_LOOKBACK_MS;
  }
}

export function useVisitCutoff(): number {
  const [cutoff] = useState(readCutoff);
  return cutoff;
}
